
/**
 * <p> This class presents a mapping between two components.</p>
 */
export class EventMappingModel {
/**
 * <p> The name of the source Event</p>
 */
output: string;
/**
 * <p> The tag of the source event in case of multiple instances.</p>
 */
outputTag: string;
/**
 * <p> The property in the emitted event.</p>
 */
outputProperty: string;
/**
 * <p> The target of the emitted event.</p>
 */
input: string;
/**
 * <p> The tag of the target component in case of multiple instances.</p>
 */
inputTag: string;
/**
 * <p> The property to map to in the target component.</p>
 */
inputProperty: string;
/**
 * It is the constructor for the mapping class. It takes the required string values to create the mapping object
 * @param {?=} values
 */
constructor(values: Object = {}) {
    Object.assign(this, values);
  }

}

function EventMappingModel_tsickle_Closure_declarations() {
/**
 * <p> The name of the source Event</p>
 * @type {?}
 */
EventMappingModel.prototype.output;
/**
 * <p> The tag of the source event in case of multiple instances.</p>
 * @type {?}
 */
EventMappingModel.prototype.outputTag;
/**
 * <p> The property in the emitted event.</p>
 * @type {?}
 */
EventMappingModel.prototype.outputProperty;
/**
 * <p> The target of the emitted event.</p>
 * @type {?}
 */
EventMappingModel.prototype.input;
/**
 * <p> The tag of the target component in case of multiple instances.</p>
 * @type {?}
 */
EventMappingModel.prototype.inputTag;
/**
 * <p> The property to map to in the target component.</p>
 * @type {?}
 */
EventMappingModel.prototype.inputProperty;
}

